import Link from 'next/link';
// Importing chosen icons from react-icons.
// I've tried to match them as closely as possible to the Lucide ones.
// You might want to explore the react-icons library for exact matches or alternatives.
import {
  FaEnvelope, FaLeaf, FaRecycle, FaGift, FaHandshake, FaEye, FaShoppingCart, FaUsers,
  FaIndustry, FaMagic, FaAward, FaGlobeAmericas, FaSyncAlt, FaBookOpen, FaCheckCircle,
  FaHeartbeat, FaChartLine, FaFacebookSquare, FaInstagramSquare, FaTwitterSquare, FaLinkedin
} from 'react-icons/fa'; // Using Font Awesome as a primary source for variety
import Image from 'next/image';
import Meta from '../../components/Meta';
import SecondDescripton from '../../components/common/SecondDescripton';
import WhoSells from '../../components/impact-shop/WhoSells';
const features = [
  {
    icon: <FaHandshake className="mx-auto mb-2 text-green-600" size={48} />,
    title: "Ethically Sourced",
    description:
      "All products are made or sourced under fair, transparent, and humane conditions.",
    bg: "bg-green-50",
  },
  {
    icon: <FaLeaf className="mx-auto mb-2 text-blue-600" size={48} />,
    title: "Sustainable & Eco-Friendly",
    description:
      "We prioritize goods that are recycled, upcycled, biodegradable, or zero-waste.",
    bg: "bg-blue-50",
  },
  {
    icon: <FaGift className="mx-auto mb-2 text-yellow-600" size={48} />,
    title: "Cause-Driven",
    description:
      "Sales support verified social and environmental campaigns.",
    bg: "bg-yellow-50",
  },
  {
    icon: <FaMagic className="mx-auto mb-2 text-purple-600" size={48} />,
    title: "Powered by Purpose",
    description:
      "Products include those created by organizations or artisans working directly with communities in need.",
    bg: "bg-purple-50",
  },
  {
    icon: <FaEye className="mx-auto mb-2 text-red-600" size={48} />,
    title: "Transparency Guaranteed",
    description:
      "Each item includes details on its origin, impact, and contribution.",
    bg: "bg-red-50",
  },
];

const sellers = [
  {
    imgSrc: "https://placehold.co/100x100/8c66fb/ffffff.png?text=Enterprise",
    alt: "Social Enterprise",
    title: "Social Enterprises",
    description: "Mission-driven businesses creating ethical, eco-friendly goods.",
  },
  {
    imgSrc: "https://placehold.co/100x100/8c66fb/ffffff.png?text=Campaign",
    alt: "Causes & Campaigns",
    title: "Causes & Campaigns",
    description: "Organizations using product sales to fund programmes or direct action.",
  },
  {
    imgSrc: "https://placehold.co/100x100/8c66fb/ffffff.png?text=Artisan",
    alt: "Artisan",
    title: "Artisans & Creators",
    description: "Local makers who prioritize sustainable materials and ethical labor.",
  },
  {
    imgSrc: "https://placehold.co/100x100/8c66fb/ffffff.png?text=Aligned",
    alt: "Impact-Aligned Enterprises",
    title: "Impact-Aligned Enterprises",
    description: "Organizations with sustainable products contributing a percentage of sales to verified impact initiatives.",
  },
];
// Main App component
const App = () => {

  return (<>
    <Meta title="Impact Shop || Impactoverse" />

    <section className="relative pt-[9rem] pb-10 lg:pb-24 text-center">
      <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
        <Image
          width={1519}
          height={773}
          priority
          src="/images/gradient_light.jpg"
          alt="gradient"
          className="h-full w-full object-cover"
        />
      </picture>
      <div className="lg:flex lg:space-x-12">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={935}
            src="/images/gradient.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
          <Image
            width={1519}
            height={935}
            src="/images/gradient_dark.jpg"
            alt="gradient dark"
            className="h-full w-full object-cover"
          />
        </picture>
      </div>
      <div className="container mx-auto text-center">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
          Purpose-Driven Products
          <span className="animate-gradient"> That Give Back</span>
          <br />
        </h1>

        <SecondDescripton text={`COMING SOON! The Impact Shop is more than just a marketplace—it’s a destination for conscious consumers.`} lg={15}></SecondDescripton>
        <Link href={'/contact-us'}
          className="mt-10 inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark uppercase"
        >
          <FaEnvelope className="inline-block mr-2" size={20} /> Notify Me When We Launch
        </Link>

      </div>
    </section>
    {/* <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 font-inter text-gray-800"> */}

    <section className="relative pt-[4rem] lg:pb-24 text-center">

      <div className="container mx-auto text-center">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
          Here&apos;s What It&apos;s
          <span className="animate-gradient"> All About</span>
          <br />
        </h1>

        <SecondDescripton text={`Every item here has been carefully selected or created to support ethical practices, sustainable living, and real-world impact. From recycled goods to artisan-made products, each product that is sold helps drive meaningful change. Whether you're shopping for yourself, your community, or a gift that matters, you're supporting causes with every transaction.`} lg={15}></SecondDescripton>


      </div>
    </section>


    {/* What Sets It Apart Section */}
    <section className="py-12 px-6 max-w-6xl mx-auto">
      <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
        What Sets Us <span className="animate-gradient"> Apart</span>
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {features.map((feature, index) => (
          <div
            key={index}
            className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
          >
            <div className="flex items-center justify-center">
              <div
                className={`rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark color-white`}
              >
                <span className='w-15 h-15'>
                  {feature.icon}
                </span>
              </div>
            </div>
            <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
              {feature.title}
            </h3>
            <p className="text-lg dark:text-jacarta-300">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>


    {/* How It Works Section */}
    <section className="relative py-24 dark:bg-jacarta-800">
      <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
        <img src="/images/gradient_light.jpg" alt="gradient" className="h-full w-full" />
      </picture>
      <div className="container">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
          How It <span className="animate-gradient"> Works</span>
        </h1>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div className="relative rounded-2.5xl border border-jacarta-100 bg-white p-10 shadow-[0_5px_0_0_#8358ff] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(131,88,255,.3)] dark:border-jacarta-700 dark:bg-jacarta-700">

            {/* <FaShoppingCart className="absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600" size={40} /> */}
            <div className="mb-6 inline-flex items-center justify-center">

              <FaShoppingCart className="h-12 w-12 fill-accent" size={40} />
            </div>
            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">
              Browse or search for products
            </h3>
            <p className="dark:text-jacarta-300">
              Discover items and makers that align with your values.
            </p>
          </div>
          <div className="relative rounded-2.5xl border border-jacarta-100 bg-white p-10 shadow-[0_5px_0_0_#8358ff] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(131,88,255,.3)] dark:border-jacarta-700 dark:bg-jacarta-700">

            {/* <FaBookOpen className="absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600" size={40} /> */}
            <div className="mb-6 inline-flex items-center justify-center">

              <FaBookOpen className="h-12 w-12 fill-accent" size={40} />
            </div>
            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">
              Learn about the impact
            </h3>
            <p className="dark:text-jacarta-300">
              Each item includes a story: who made it, how it&apos;s made, and the cause it supports.
            </p>
          </div>
          <div className="relative rounded-2.5xl border border-jacarta-100 bg-white p-10 shadow-[0_5px_0_0_#8358ff] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(131,88,255,.3)] dark:border-jacarta-700 dark:bg-jacarta-700">

            {/* <FaAward className="absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600" size={40} /> */}
            <div className="mb-6 inline-flex items-center justify-center">

              <FaAward className="h-12 w-12 fill-accent" size={40} />
            </div>
            <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white">
              Buy with confidence
            </h3>
            <p className="dark:text-jacarta-300">
              All sales support impactful outcomes.
            </p>
          </div>
        </div>
      </div>
    </section>

<WhoSells></WhoSells>
    {/* Who Sells Through the Impact Shop Section */}
    {/* <section className="py-12 px-6 max-w-6xl mx-auto">
      <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
        Who Sells Through <span className="animate-gradient"> The Impact Shop?</span>
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {sellers.map((seller, index) => (
          <div
            key={index}
            className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
          >
            <div className="flex items-center justify-center">
              <div
                className={`rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark color-white`}
              >
                <img
                  src={seller.imgSrc}
                  alt={seller.alt} className="mx-auto mb-4 rounded-full" />
              </div>
            </div>
            <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
              {seller.title}
            </h3>
            <p className="text-lg dark:text-jacarta-300">
              {seller.description}
            </p>
          </div>
        ))}
      </div>
    </section> */}


    {/* Product Features That Matter Section */}
    <section className="py-12 px-6 max-w-6xl mx-auto">
      <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
        Product Features <span className="animate-gradient"> That Matter</span>
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {[
          { icon: <FaRecycle className="text-blue-500" size={24} />, text: "Made using recycled, reclaimed, or upcycled materials" },
          { icon: <FaGlobeAmericas className="text-green-500" size={24} />, text: "Designed for low environmental impact and minimal waste" },
          { icon: <FaSyncAlt className="text-purple-500" size={24} />, text: "Prioritizes biodegradability, reusability, or circularity" },
          { icon: <FaUsers className="text-red-500" size={24} />, text: "Crafted under ethical labor conditions with transparent sourcing" },
          { icon: <FaIndustry className="text-orange-500" size={24} />, text: "Handmade or locally produced to reduce carbon footprint" },
          { icon: <FaHeartbeat className="text-pink-500" size={24} />, text: "Created in partnership with or by organizations working on the ground" },
          { icon: <FaChartLine className="text-teal-500" size={24} />, text: "Designed to raise funds or awareness for specific impact campaigns" },
        ].map((feature, index) => (
          <div
            key={index}
            className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
          >
            <div className="flex items-center justify-center">
              <div
                className={`rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark color-white`}
              >
                {feature.icon}
              </div>
            </div>
            <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
              {feature.text}
            </h3>
          </div>
        ))}
      </div>
    </section>

    {/* Why Shop With Us Section */}

   <section className="pb-0">
  <div className="container">
    <div className="rounded-2.5xl bg-light-base px-10 py-10 text-center dark:bg-jacarta-700">
      <div>
        <h2 className="mb-5 font-extrabold text-3xl sm:text-4xl md:text-5xl leading-tight drop-shadow-md">
          Why Shop With Us?
        </h2>
      </div>
      <div className="m-auto">
        <ul className="text-lg sm:text-xl mb-10 space-y-4 text-start dark:text-jacarta-300">
          {[
            "Every purchase supports people and planet.",
            "You’re voting for better business with your wallet.",
            "You help scale small makers, ethical brands, and campaign-led initiatives.",
            "You get something meaningful and sustainable.",
          ].map((text, index) => (
            <li key={index} className="grid grid-cols-[auto_1fr] gap-3 items-start">
              <span className="text-accent mt-1">
                <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                </svg>
              </span>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="mb-20"></div>
  </div>
</section>


    {/* Apply to Sell Section */}

    <section className="pb-0">
      <div className="container">
        <div className="rounded-2.5xl bg-light-base px-10 py-10 text-center dark:bg-jacarta-700">
          <div>
            <h2 className="mb-5 font-extrabold text-3xl sm:text-4xl md:text-5xl leading-tight drop-shadow-md">
              Ready to Make an Impact?
            </h2>
          </div>
          <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto dark:text-jacarta-300">
            If you&apos;re a social enterprise, cause, artisan, or impact-aligned business, we&apos;d love to partner with you.
          </p>

          <Link
            href="/contact-us"
            target="_blank"
            className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark uppercase"
          >
            Apply To Sell With Us
          </Link>
          {/* <p className="mt-8 text-lg opacity-80 max-w-2xl mx-auto">
              Art isn’t just symbolic, it’s functional. Every contribution,
              sale, share, and story moves a cause forward.
            </p> */}
        </div>
        <div className="mb-20"></div>
      </div>
    </section>

    {/* </div> */}
  </>
  );
};

export default App;